
import Tag from './tag';

function tag(props) {
  return new Tag(props);
}

export default tag;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/tag/index.js
// module id = 173
// module chunks = 9